// removed by extract-text-webpack-plugin
module.exports = {"slider":"_1dRD35NrjzZuxnIWn8jJiP","slider_wrapper":"_shdWLYT_twTuHOv5v_eK","slide":"_13YbUI9F-rj3L1M9rs4FbJ","itemImage":"VeubYs_biSj0TCudR2Rh5","arrow":"_3SxuQzPGVfcWNL7ZHGuCBz","nextArrow":"_3GkeAVrzJGn40C_H-O-WP_","backArrow":"_3ySdwW13RMhc6J2pH6VZq5","fa-arrow-right":"_2aUbg7PpdszCHV_hbsR41J","fa-arrow-left":"_1U5ST6sHuZWH_iUzjeSpOz","dot":"AhIpY8KvA-iXSdvAz4Xz6","dotStyle":"G_v64HJay-zqZLpuV_uvc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/SwipeBanner.scss
// module id = 1125
// module chunks = 0